<template>
  <div class="flex h-full">
    <div
      class="flex flex-col flex-1 justify-center px-4 py-20 sm:px-6 lg:flex-none lg:px-20 xl:px-36"
    >
      <img class="absolute top-8 left-12" src="@/assets/logos/csm.svg" />
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <h2 class="mt-6 text-5xl font-semibold text-center">
            Invoicing Tool
          </h2>
        </div>
        <div class="mt-12">
          <router-view />
        </div>
      </div>
    </div>
    <div class="hidden relative flex-1 w-0 lg:block">
      <div
        :style="{
          backgroundImage: `url(${require('@/assets/backgrounds/splash.png')}`,
        }"
        class="absolute w-full h-full bg-no-repeat bg-cover"
      ></div>
    </div>
  </div>
</template>
